import { html, SYSBaseElement } from "../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../_ovlclient/src"
import { DialogClose } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import type { DialogHolderParams } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import { TableGet } from "../../../../../_ovlclient/src/library/table/tableapi"
import { RefreshResultingPermission } from "../helpers"
import { UserAdministration_UserRoleType } from "../userrole/tabledef"
import { UserAdministration_RoleType } from "../role/tabledef"
import { NavDef } from "../../../../../_ovlclient/src/library/table/navcontrol"

export class DialogSYSUserAdministrationPermission extends SYSBaseElement {
  async init() {
    this.dialog = "SYSUserAdministration_Permission"
    await super.init()
  }
  async getUI() {
    let selectedRoleTable = TableGet<UserAdministration_RoleType>(
      "SYSUserAdministration_Role",
      { byKeys: "Selected" }
    )
    let selectedRole = selectedRoleTable.rows[selectedRoleTable.getKeys()[0]]
    let role = selectedRole.Code

    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSUserAdministration_Permission",
        closedCallbackFn: () => {
          let userRoleTable = TableGet<UserAdministration_UserRoleType>(
            "SYSUserAdministration_UserRole",
            { byKeys: "Selected" }
          )
          if (userRoleTable.getKeys().length > 0) {
            let selectedUserCode =
              userRoleTable.rows[userRoleTable.getKeys()[0]].U_CntctCode
            RefreshResultingPermission(selectedUserCode)
          }
        },
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () =>
          html`<h4>
            <b>${T("SYSUserAdministrationPermissionTitle")}</b> ${role}
          </h4>`,

        body: () =>
          html`<comp-sysuseradministrationpermission></comp-sysuseradministrationpermission> `,
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
